import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';

import sitesClient from '@/core/api/sites-service';
import { LOADING_CONTENT } from '@/core/store/types/action-types';
import qualityClient from '@/core/api/quality-service';

import { SiteCustomerListItemDTO } from '@/../client-generator/generated-clients/sites';
import { ContradictoryCheckDTO, IContradictoryCheckDTO } from '@/../client-generator/generated-clients/quality';

@Component
export default class RequestControl extends Vue {
  sites: SiteCustomerListItemDTO[] = [];
  siteId = '';

  formModel: IContradictoryCheckDTO = {
    text: '',
    timestamp: new Date(),
    controlDate: new Date(),
    siteId: '',
  };

  get formRules() {
    const required = {
      required: true,
      message: this.$t('validation.fieldRequired'),
    };

    return {
      siteId: required,
      text: [required],
      controlDate: [required],
    };
  }

  mounted() {
    this.fetchSites();
  }

  async fetchSites() {
    this.$store.dispatch(LOADING_CONTENT, true);
    try {
      const response = await sitesClient.myList(undefined);
      this.sites = response.data as SiteCustomerListItemDTO[];
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.$store.dispatch(LOADING_CONTENT, false);
    }
  }

  submit() {
    const $form = this.$refs.theForm as Form;

    $form.validate(async (isValid) => {
      if (isValid) {
        this.$store.dispatch(LOADING_CONTENT, true);

        try {
          const contradictoryCheckDTO = new ContradictoryCheckDTO({
            ...this.formModel,
            timestamp: this.formModel.controlDate,
          });

          await qualityClient.contradictoryCheckPost(contradictoryCheckDTO);
          this.$message.success(this.$t('requestSent').toString());
          this.backToList();
        } catch (error) {
          let messageError = 'error';

          switch (error.status) {
            case 401:
              messageError = this.$t('apiErrors.unauthorized').toString();
              break;
            case 403:
              messageError = this.$t('apiErrors.forbidden').toString();
              break;
            default:
              messageError = this.$t('apiErrors.serverError').toString();
          }

          this.$message.error(messageError);
        } finally {
          this.$store.dispatch(LOADING_CONTENT, false);
        }
      }
    });
  }

  backToList() {
    this.$router.push({
      name: 'page-quality-controls',
    });
  }
}
